/**
 * Mobile Player Search Page - Placeholder
 * Will show: Search bar, filter buttons, player cards
 */

import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

const C = dynastyTheme.tokens.colors;

function MobilePlayerSearch() {
  return (
    <div style={{
      padding: '20px',
      paddingBottom: '0',
      minHeight: '100vh',
      backgroundColor: 'transparent',
      color: C.white
    }}>
      <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>
        Player Search
      </h1>
      <div style={{
        padding: '20px',
        backgroundColor: C.surface[870],
        borderRadius: '8px',
        marginBottom: '15px'
      }}>
        <p style={{ fontSize: '16px', color: C.coolGray[500] }}>
          Coming Soon:
        </p>
        <ul style={{ marginTop: '10px', color: C.coolGray[250] }}>
          <li>Search all players</li>
          <li>Filter by position, team</li>
          <li>Free agent availability</li>
          <li>Tap to see player details</li>
        </ul>
      </div>
    </div>
  );
}

export default MobilePlayerSearch;
